import { useEffect, useState, useRef } from "react";
import "../styles/gis/gis.scss";
import GISHeader from "../components/gis/gisheader";
import LoadingWidget from "../components/loading";
import { FaLayerGroup, FaTimes, FaMapMarkerAlt, FaMap, FaLocationArrow, FaImage, FaReply, FaBell } from "react-icons/fa"; // Icons
import myData from "../assets/data/data";
import Map from "ol/Map";
import View from "ol/View";
import Icon from 'ol/style/Icon';
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import Overlay from "ol/Overlay"; // Import Overlay for popup
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import MultiPolygon from "ol/geom/MultiPolygon";
import MultiLineString from "ol/geom/MultiLineString";
import { ZoomToExtent, defaults as defaultControls } from "ol/control";
import { fromLonLat } from "ol/proj";
import { XYZ } from "ol/source";
import { Style, Circle as CircleStyle, Fill, Stroke } from "ol/style";
import Legend from "../components/gis/legend";
import MenuTab from "../components/menu_tab";
import northarrow from "../assets/icons/north-arrow.png"
import { locateUser } from "../components/gis/locateUser";
import html2canvas from "html2canvas";
import SearchBar from "../components/searchbar";
import { getBoreholeSVG, getBulkMeterSVG, getColoredMeterSVG, getControlValveSVG, getOfftakeSVG, getTankSVG, getTreatmentWorksSVG, getWeirSVG } from "../assets/icons/legendicons/mlegendicons";

export default function Incidences() {
  // const [tanks, setTanks] = useState([]);
  const [toggleMenu, setToggleMenu] = useState(false);
  const [map, setMap] = useState(null);
  const [basemapSelected, setBasemapSelected] = useState(0);
  const [basemapsVisible, setBasemapsVisible] = useState(true);
  const [legendCollapsed, setLegendCollapsed] = useState(true);
  const [layers, setLayers] = useState({
    Wards: {
      url: "/api/wardsserved",
      data: [],
      visibility: true,
      attribute: "subcounty",
      filters: { Githunguri: true, "Lari": true },
      colors: { Githunguri: "#ff00ee", "Lari": "#540066" },
    },
    Incidences: {
      url: "/api/incidences",
      data: [],
      visibility: true,
      attribute: "Type",
      filters: { "Burst Pipe": true,
        "Leakage": true,
        "Vandalism": true,
        "Illegal Connection": true,
        "Blocked Drain": true,
        "Low Pressure": true,
        "No Water": true,
        "Overflow": true,
        "Other": true },
      colors: {
        "Burst Pipe": "#540066",            // Deep Purple
        "Leakage": "#007bff",               // Bright Blue
        "Vandalism": "#ff4d4d",             // Vivid Red
        "Illegal Connection": "#ffa500",    // Orange
        "Blocked Drain": "#964B00",         // Brown
        "Low Pressure": "#00ced1",          // Dark Turquoise
        "No Water": "#000000",              // Black
        "Overflow": "#00ff7f",              // Spring Green
        "Other": "#ff00ee"                  // Magenta (as you had)
      }

    },
    // SupplyLines: {
    //   url: "/api/latestsupplylines",
    //   data: [],
    //   visibility: true,
    //   attribute: "status",
    //   filters: { Existing: true, Proposed: true, Damaged: true, Abandoned: true },
    //   colors: { Existing: "blue", Proposed: "#39FF14", Damaged: "red", Abandoned: "brown" },
    // },
    // Weirs: {
    //   url: "/api/latestweirs",
    //   data: [],
    //   visibility: false,
    //   attribute: "status",
    //   filters: { Active: true, "Inactive": true },
    //   colors: { Active: "purple", "Inactive": "red" },
    // },
    // Boreholes: {
    //   url: "/api/latestboreholes",
    //   data: [],
    //   visibility: true,
    //   attribute: "status",
    //   filters: { Active: true, Inactive: true },
    //   colors: { Active: "#BF00FF", Inactive: "yellow" },
    // },
    // Offtakes: {
    //   url: "/api/latestofftakes",
    //   data: [],
    //   visibility: true,
    //   attribute: "status",
    //   filters: { Active: true, Inactive: true },
    //   colors: { Active: "#000000", Inactive: "#FFFFFF" },
    // },
    // ControlValves: {
    //   url: "/api/latestcontrolvalves",
    //   data: [],
    //   visibility: false,
    //   attribute: "status",
    //   filters: { Active: true, Inactive: true },
    //   colors: { Active: "blue", Inactive: "yellow" },
    // },
    // Bulkmeters: {
    //   url: "/api/latestbulkmeters",
    //   data: [],
    //   visibility: false,
    //   attribute: "status",
    //   filters: { Active: true, Inactive: true },
    //   colors: { Active: "#FFA500", Inactive: "#40E0D0" },
    // },
    // "T-Works": {
    //   url: "/api/latesttworks",
    //   data: [],
    //   visibility: true,
    //   attribute: "status",
    //   filters: { Operational: true, "Not Operational": true },
    //   colors: { Operational: "blue", "Not Operational": "#00FFFF" },
    // },
    // Tanks: {
    //   url: "/api/latesttanks",
    //   data: [],
    //   visibility: true,
    //   attribute: "status",
    //   filters: { Operational: true, "Not Operational": true },
    //   colors: { Operational: "green", "Not Operational": "red" },
    // },
  });

  const [isLoading, setIsLoading] = useState(true);

  const mapElement = useRef();
  const popupElement = useRef();
  const popupOverlay = useRef();

  useEffect(() => {
    const fetchData = async () => {
      const requests = Object.entries(layers).map(([key, layer]) =>
        fetch(layer.url)
          .then((res) => (res.ok ? res.json() : Promise.reject(`Failed: ${key}`)))
      );
  
      const responses = await Promise.allSettled(requests);
  
      const updatedLayers = { ...layers };
      
      Object.keys(layers).forEach((key, i) => {
        if (responses[i].status === "fulfilled") {
          
          updatedLayers[key].data = responses[i].value.data;
          setIsLoading(false);
        } else {
          console.error(`Error fetching ${key}:`, responses[i].reason);
        }
      });
  
      setLayers(updatedLayers);
    };
  
    fetchData();
  }, []);
   

  useEffect(() => {
    // const basemapLayer = new TileLayer({
    //   source: new XYZ({
    //     url: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    //     crossOrigin: "Anonymous",
    //   }),
    // });

    const basemapLayer = new TileLayer({
      title: "Basemaps",
      // visible: basemapsVisible,
      source: new XYZ({
        url: myData[basemapSelected].url,
        crossOrigin: "Anonymous",
      }),
    });

    const initialMap = new Map({
      target: mapElement.current,
      layers: [basemapLayer],
      view: new View({
        projection: "EPSG:3857",
        center: fromLonLat([36.777382, -1.040343]),
        zoom: 12.5,
        maxZoom: 32,
      }),
      controls: defaultControls().extend([
        new ZoomToExtent({
          extent: [
            ...fromLonLat([36.6970, -1.1335]),
            ...fromLonLat([36.8846, -0.9800]),
          ],
        }),
      ]),
    });

    setMap(initialMap);

    return () => initialMap.setTarget(undefined);
  }, []);

  useEffect(() => {
    if (!map) return;
  
    const basemapLayer = map
      .getLayers()
      .getArray()
      .find((layer) => layer.get("title") === "Basemaps");
  
    if (basemapLayer) {
      // Change Basemap when basemapSelected
      basemapLayer.setSource(
        new XYZ({
          url: myData[basemapSelected].url,
          crossOrigin: "Anonymous",
        })
      );
      // Hide layer when debasemapSelected
      basemapLayer.setVisible(basemapsVisible);
    }
  }, [basemapSelected, basemapsVisible]);
  
  useEffect(() => {
    if (!map) return;

    popupOverlay.current = new Overlay({
      element: popupElement.current,
      autoPan: true,
      positioning: "bottom-center",
      offset: [0, -15],
    });

    map.addOverlay(popupOverlay.current);

    map.on("singleclick", (event) => {
      const feature = map.forEachFeatureAtPixel(event.pixel, (feat) => feat);

      if (feature) {
        const properties = feature.getProperties();
        delete properties.geometry;

        const contentHTML = `
          <table class="popup-table">
            ${Object.entries(properties)
              .map(
                ([key, value]) =>
                  `<tr><td><strong>${key}:</strong></td><td>${value}</td></tr>`
              )
              .join("")}
          </table>
          <button class="popup-zoom" id="zoomToFeatureBtn">Zoom to Feature</button>
        `;

        document.getElementById("popup-content").innerHTML = contentHTML;
        popupOverlay.current.setPosition(event.coordinate);

        setTimeout(() => {
          const btn = document.getElementById("zoomToFeatureBtn");
          if (btn) {
            btn.onclick = () => {
              const geometry = feature.getGeometry();
              const extent = geometry.getExtent();
              map.getView().fit(extent, { maxZoom: 17, duration: 1000 });
            };
          }
        }, 200);
      } else {
        popupOverlay.current.setPosition(undefined);
      }
    });
  }, [map]);

  useEffect(() => {
    if (!map) return;

    const svgGenerators = {
      "Customer Meters": getColoredMeterSVG,
      "Tanks": getTankSVG,
      "ControlValves": getControlValveSVG,
      "Boreholes": getBoreholeSVG,
      "Weirs": getWeirSVG,
      "T-Works": getTreatmentWorksSVG,
      "Offtakes": getOfftakeSVG,
      "Bulkmeters": getBulkMeterSVG,
    };

    if (map) {
      Object.entries(layers).forEach(([layerName, layerConfig]) => {
        let vectorLayer = map
          .getLayers()
          .getArray()
          .find((l) => l.get("title") === layerName);
  
        if (!vectorLayer) {
          vectorLayer = new VectorLayer({
            title: layerName,
            source: new VectorSource(),
          });
          map.addLayer(vectorLayer);
        }
  
        const source = vectorLayer.getSource();
        source.clear();     
  
        if (layerConfig.visibility && layerConfig.data) {
          const styleCache = {};
          const attribute = layerConfig.attribute;
          const iconGenerator = svgGenerators[layerName]; 
        
          const features = layerConfig.data
            .filter((item) => item.geom && layerConfig.filters[item[attribute]])
            .map((item) => {
              let feature;
              
              // Handle MultiLineString Geometry
              if (item.geom?.type === "MultiLineString") {
                const coordinates = item.geom?.coordinates[0].map(([lon, lat]) =>
                  fromLonLat([lon, lat])
                );  
                feature = new Feature({
                  geometry: new MultiLineString([coordinates]),
                  status: item[attribute],
                });
        
                if (!styleCache[item[attribute]]) {
                  styleCache[item[attribute]] = new Style({
                    stroke: new Stroke({
                      color: layerConfig.colors[item[attribute]],
                      width: 1.5,
                    }),
                  });
                }
              }
        
              // Handle Point Geometry
              else if (item.geom.type === "Point") {
                const [lon, lat] = item.geom.coordinates;
                feature = new Feature({
                  geometry: new Point(fromLonLat([lon, lat])),
                  ...item,
                });

                if (!styleCache[item[attribute]]) {
                  // Use SVG generator if available
                  if (iconGenerator) {
                    const svgUrl = iconGenerator(layerConfig.colors[item[attribute]]);
                    styleCache[item[attribute]] = new Style({
                      image: new Icon({
                        src: svgUrl,
                        anchor: [0.5, 0.5],
                        scale: 1.0,
                        crossOrigin: "anonymous",
                      }),
                    });
                  } else {
                    // Fallback to simple colored circle
                    styleCache[item[attribute]] = new Style({
                      image: new CircleStyle({
                        radius: 6,
                        fill: new Fill({ color: `${layerConfig.colors[item[attribute]]}09` }),
                        stroke: new Stroke({ color: "#fff", width: 1 }),
                      }),
                    });
                  }
                }
              }
        
              // Handle MultiPolygon Geometry
              else if (item.geom.type === "MultiPolygon") {
                feature = new Feature({
                  geometry: new MultiPolygon(
                    item.geom.coordinates.map((polygon) =>
                      polygon.map((ring) =>
                        ring.map(([lon, lat]) => fromLonLat([lon, lat]))
                      )
                    )
                  ),
                  status: item[attribute],
                });
        
                if (!styleCache[item[attribute]]) {
                  styleCache[item[attribute]] = new Style({
                    stroke: new Stroke({ color: layerConfig.colors[item[attribute]], width: 0.7 }),
                    fill: new Fill({ color: `${layerConfig.colors[item[attribute]]}09` }), // If colors are hex codes

                  });
                }
              }
        
              if (feature) {
                feature.setStyle(styleCache[item[attribute]]);
                return feature;
              }
            });
        
          if (source) {
            source.addFeatures(features.filter(Boolean));
            // if (features.length > 0) {
            //   const extent = source.getExtent();
            //   map.getView().fit(extent, { padding: [30, 200, 80, 50], maxZoom: 18 });
            // }
          }
        }
        
  
        vectorLayer.setVisible(layerConfig.visibility);
      });
    }
  }, [map, layers]);  


  const exportMap = () => {
    if (!map) return;

    const title = prompt("Enter a title for the map:", "My Map Title");
    if (title === null) return; // Cancelled

    map.once("rendercomplete", () => {
      const mapCanvas = map.getViewport().querySelector("canvas");
      if (!mapCanvas) return;

      const exportCanvas = document.createElement("canvas");
      exportCanvas.width = mapCanvas.width;
      exportCanvas.height = mapCanvas.height;

      const ctx = exportCanvas.getContext("2d");
      ctx.drawImage(mapCanvas, 0, 0);

      const legend = document.querySelector(".legend");
      const northArrow = new Image();
      northArrow.src = northarrow;

      northArrow.onload = () => {
        // 🧭 North Arrow – Top Right
        ctx.drawImage(northArrow, exportCanvas.width - 250, 160, 245, 260);

        // 📏 Static Scale Bar – Bottom Left
        ctx.fillStyle = "black";
        ctx.fillRect(exportCanvas.width - 180, exportCanvas.height - 60, 100, 6);

        ctx.fillStyle = "white";
        ctx.font = "14px sans-serif";
        ctx.textAlign = "left";
        ctx.textBaseline = "bottom";
        ctx.fillText("100m", exportCanvas.width - 170, exportCanvas.height - 65);

        // 🖋️ Map Title – Top Center with white background
        const titleFontSize = 50;
        ctx.font = `bold ${titleFontSize}px Arial`;
        ctx.textAlign = "center";
        ctx.textBaseline = "top";

        const textWidth = ctx.measureText(title).width;
        const textX = exportCanvas.width / 2;
        const textY = 30;
        const padding = 40;

        // White background for title
        ctx.fillStyle = "white";
        ctx.fillRect(
          textX - textWidth / 2 - padding / 2,
          textY - padding / 2,
          textWidth + padding,
          titleFontSize + padding
        );

        // Draw title text
        ctx.fillStyle = "black";
        ctx.font = `bold ${titleFontSize}px Arial`; // Reset font before drawing
        ctx.fillText(title, textX, textY);

        // 🪧 Watermark – Bottom Left
        ctx.font = "italic 18px Arial";
        ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
        ctx.textAlign = "left";
        ctx.textBaseline = "bottom";
        ctx.fillText("© Githunguri Water and Sanitation Company Ltd.", 20, exportCanvas.height - 20);

        // 🖼️ Render Legend – Bottom Right
        if (legend) {
          html2canvas(legend).then((legendCanvas) => {
            const legendX = exportCanvas.width - legendCanvas.width - 30;
            const legendY = exportCanvas.height - legendCanvas.height - 30;
            ctx.drawImage(legendCanvas, legendX, legendY);

            // 📥 Download
            const link = document.createElement("a");
            link.download = "map_export.png";
            link.href = exportCanvas.toDataURL("image/png");
            link.click();
          });
        } else {
          // No legend – just download
          const link = document.createElement("a");
          link.download = "map_export.png";
          link.href = exportCanvas.toDataURL("image/png");
          link.click();
        }
      };
    });

    map.renderSync();
  };

  return (
    <div className="gis">
      <GISHeader toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />

      {toggleMenu && (
        <MenuTab toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      )}

      <div className="map">
        {isLoading && <LoadingWidget />}

        <div className="map_container" ref={mapElement}>
          <div ref={popupElement} className="ol-popup">
            <button
              className="ol-popup-closer"
              onClick={() => popupOverlay.current.setPosition(undefined)}
            >
              <FaTimes />
            </button>
            <div id="popup-content"></div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="map-buttons">
          <button onClick={() => locateUser(map)}><FaMapMarkerAlt/></button>
          <button onClick={() => {
            setLegendCollapsed(false);
            exportMap();
          }}><FaMap/></button>
        </div>

        {/* Search and Legend */}
        {/* <SearchBar layers={layers} setLayers={setLayers} /> */}
        <div className="search-bar">
          <button className="search-btn" onClick={() => window.location.href="/incidences/report"}>
                <FaBell />
        </button>
        </div>
        {legendCollapsed ? (
          <button
            className="legend-toggle custom-icon"
            onClick={() => setLegendCollapsed(false)}
          >
            <FaLayerGroup />
          </button>
        ) : (
          <Legend
            layers={layers}
            setLayers={setLayers}
            myData={myData}
            legendCollapsed={legendCollapsed}
            setLegendCollapsed={setLegendCollapsed}
            basemapsVisible={basemapsVisible}
            setBasemapsVisible={setBasemapsVisible}
            basemapSelected={basemapSelected}
            setBasemapSelected={setBasemapSelected}
          />
        )}
      </div>
    </div>
  );
}
